import { useId } from 'react';
import { cn } from '@/lib/utils';

/**
 * RAD Finance — Logo (mark)
 * --------------------------------------------------------------------------
 * Marca da aplicação, renderizada como SVG inline (sem assets externos). Um
 * quadrado arredondado em verde da marca RAD com uma linha de tendência em alta
 * — referência a crescimento/finanças. A mesma marca é usada no favicon
 * (`public/favicon.svg`), na sidebar e no login, garantindo consistência
 * visual. `size` define o lado em px.
 */
export function Logo({ size = 28, className }: { size?: number; className?: string }) {
  const gradId = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      role="img"
      aria-label="RAD Finance"
      className={cn('shrink-0 select-none', className)}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#9BE04A" />
          <stop offset="1" stopColor="#6CB31C" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="7" fill={`url(#${gradId})`} />
      {/* Linha de tendência em alta (crescimento financeiro) */}
      <polyline
        points="6,22 13,16 18,19 25,9"
        stroke="#FFFFFF"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Ponta de seta de alta */}
      <path
        d="M25 9 L19.3 9 M25 9 L25 14.7"
        stroke="#FFFFFF"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
